import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BusResponse } from '../../participante/models/processo-manual.model';
import { ArquivoDocumentoManualDTO } from '../../documento/models/proposta-manual-documento.model';
import { DadosProposta } from '../models/dados-proposta.model';
import { PROPOSTA_FINANCIAMENTO_REPOSITORY, PropostaFinanciamentoRepository } from '../repositories/proposta-financiamento.repository';

@Injectable({
  providedIn: 'root'
})
export class FinalizarDadosPropostaUseCase {
  constructor(
    @Inject(PROPOSTA_FINANCIAMENTO_REPOSITORY) private readonly repository: PropostaFinanciamentoRepository
  ) {}

  execute(matricula: string, dados: DadosProposta): Observable<BusResponse<ArquivoDocumentoManualDTO>> {
    return this.repository.finalizarDadosPropostaManual(matricula, dados);
  }
}
